import React from "react";
import { CheckCircle2, ShieldCheck, Zap } from "lucide-react";

const BULLETS = [
  {
    icon: Zap,
    title: "Fast, no bloat",
    text: "Loads instantly, works offline-first, keyboard-friendly for busy front desks.",
  },
  {
    icon: ShieldCheck,
    title: "Your data, always yours",
    text: "End-to-end encryption. Export or delete your patient data anytime.",
  },
  {
    icon: CheckCircle2,
    title: "Built with dentists",
    text: "Co-designed with practitioners across India — obsessive about the details that matter.",
  },
];

const About = () => (
  <section id="about" className="bg-white py-20 md:py-28">
    <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#14B8A6] mb-3">
          About Dotmedy
        </div>
        <h2
          className="text-3xl md:text-[42px] font-extrabold text-[#0F2A5F] leading-tight mb-5"
          style={{ fontFamily: "'Open Sans', sans-serif" }}
        >
          Software that feels like an extra set of trained hands.
        </h2>
        <p className="text-slate-600 text-lg leading-relaxed mb-6">
          Dotmedy.com is an online platform exclusive for Dentists, built by
          engineers from IITs & RECs and reviewed by practicing clinicians.
          One-stop for records, charting, scheduling, and billing — so you can
          focus on patients, not paperwork.
        </p>
        <div className="space-y-4">
          {BULLETS.map((b) => (
            <div key={b.title} className="flex gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#E6F7F5] text-[#14B8A6] flex items-center justify-center flex-shrink-0">
                <b.icon size={18} />
              </div>
              <div>
                <div className="font-bold text-[#0F2A5F] text-[15px]">{b.title}</div>
                <div className="text-sm text-slate-600 mt-0.5">{b.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Chart preview mock */}
      <div className="relative">
        <div className="rounded-2xl bg-white border border-slate-200 shadow-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div>
              <div className="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Patient</div>
              <div className="font-bold text-[#0F2A5F]">Rohan Kapoor • UHID 16022013</div>
            </div>
            <div className="text-xs bg-[#E6F7F5] text-[#14B8A6] px-2 py-1 rounded font-semibold">FDI</div>
          </div>

          <div className="space-y-2">
            {[
              ["18", "17", "16", "15", "14", "13", "12", "11", "21", "22", "23", "24", "25", "26", "27", "28"],
              ["48", "47", "46", "45", "44", "43", "42", "41", "31", "32", "33", "34", "35", "36", "37", "38"],
            ].map((row, ri) => (
              <div key={ri} className="flex gap-1 justify-center">
                {row.map((tn, i) => {
                  const highlight = ["16", "26", "36", "46"].includes(tn);
                  const cavity = ["14", "37"].includes(tn);
                  return (
                    <div
                      key={tn}
                      className={`w-6 h-8 rounded border text-[9px] font-semibold flex items-center justify-center ${
                        cavity
                          ? "bg-red-100 border-red-300 text-red-700"
                          : highlight
                          ? "bg-[#E6F7F5] border-[#14B8A6] text-[#0F8A7D]"
                          : "bg-white border-slate-200 text-slate-500"
                      }`}
                    >
                      {tn}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>

          <div className="mt-5 pt-4 border-t border-slate-100 flex flex-wrap gap-3 text-[11px]">
            <span className="inline-flex items-center gap-1.5">
              <span className="w-3 h-3 rounded bg-red-100 border border-red-300" /> Cavity (14, 37)
            </span>
            <span className="inline-flex items-center gap-1.5">
              <span className="w-3 h-3 rounded bg-[#E6F7F5] border border-[#14B8A6]" /> Filled
            </span>
            <span className="inline-flex items-center gap-1.5 text-slate-500">
              <span className="w-3 h-3 rounded bg-white border border-slate-200" /> Healthy
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default About;
